import { combineReducers } from "redux";
import auth from "../reducers/auth/authReducer";
import dashboard from "../reducers/dashboard/dashboardReducer";
import profile from "../reducers/profile/profileReducer";

import user_preference from "../reducers/userPreference/preferenceReducer.js";

import loading from "../reducers/loading/loadingReducer";

const rootReducer = combineReducers({
  auth,
  dashboard,
  profile,
  user_preference,
  loading,
});
export default rootReducer;
